<template>
  <div class="page-container" style="padding: 20px;">
    <!-- 头部 + 返回按钮 -->
    <div style="display: flex; align-items: center; margin-bottom: 20px;">
      <el-button icon="el-icon-arrow-left" @click="goBack">返回</el-button>
      <div style="margin-left: 15px; font-size: 16px;">
        学校：
        <span style="color: #409EFF; font-weight: bold;">{{ schoolName }}</span>
      </div>
    </div>

    <!-- 学期列表 -->
    <el-table :data="semesterList" border stripe>
      <el-table-column label="学年" prop="year" width="120" />
      <el-table-column label="学期" width="130">
        <template slot-scope="scope">
          <el-tag :type="scope.row.term === 1 ? 'primary' : 'warning'">
            {{ scope.row.term === 1 ? '第一学期' : '第二学期' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="开始时间" width="180">
        <template slot-scope="scope">{{ formatTime(scope.row.startTime) }}</template>
      </el-table-column>
      <el-table-column label="结束时间" width="180">
        <template slot-scope="scope">{{ formatTime(scope.row.endTime) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.status === 1
                ? 'success'
                : scope.row.status === 2
                ? 'danger'
                : 'info'
            "
          >
            {{
              scope.row.status === 1
                ? "启用"
                : scope.row.status === 2
                ? "结束"
                : "未开始"
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status!=2" type="text" @click="toEdit(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 修改结束时间弹窗 -->
    <el-dialog title="修改结束时间" :visible.sync="editVisible" width="500px" center>
      <el-form :model="form" label-width="100px">
        <el-form-item label="学年">
          <el-input v-model="form.year" disabled />
        </el-form-item>
        <el-form-item label="学期">
          <el-tag :type="form.term === 1 ? 'primary' : 'warning'">
            {{ form.term === 1 ? "第一学期" : "第二学期" }}
          </el-tag>
        </el-form-item>
		<el-form-item label="开始时间">
		  <el-date-picker
		    v-model="form.startTime"
			disabled
		    type="date"
		    placeholder="选择开始时间"
		    value-format="timestamp"
		    style="width: 100%"
		  />
		</el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="endTime"
            type="date"
            placeholder="选择结束时间"
            value-format="timestamp"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="doUpdate">确认保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SchoolSemesterDetailPage",
  data() {
    return {
      schoolId: "",
      schoolName: "",
      semesterList: [],
      editVisible: false,
      form: {},
      endTime: ""
    };
  },
  created() {
    // 从路由获取参数
    this.schoolId = this.$route.query.schoolId;
    this.schoolName = this.$route.query.schoolName;
    this.getList();
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    // 获取学期列表
    getList() {
		//只查第一页100条够了  不要修改这里 涉及缓存问题
      this.API.get(this.API.admin.getSchoolSemesterList, {
          schoolId: this.schoolId,
          pageNum: 1,
          pageSize: 100
      })
      .then((res) => {
          this.semesterList = res.data.data.records;
      });
    },

    // 打开修改
    toEdit(row) {
      this.form = { ...row };
      this.endTime = row.endTime;
      this.editVisible = true;
    },

    // 提交修改（只改结束时间）
    doUpdate() {
      // 1. 选择的日期 转 当天 23:59:59 时间戳
      let date = new Date(this.endTime);
      let endOfDay = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23, 59, 59
      ).getTime();

      // 2. 判断不能和开始时间同一天
      let startDate = new Date(this.form.startTime);
      let endDate = new Date(endOfDay);
      let isSameDay = startDate.getFullYear() === endDate.getFullYear()
          && startDate.getMonth() === endDate.getMonth()
          && startDate.getDate() === endDate.getDate();

      if (isSameDay) {
        return this.$message.error("结束时间不能与开始时间为同一天！");
      }

      // 3. 结束时间不能小于开始时间
      if (endOfDay < this.form.startTime) {
        return this.$message.error("结束时间不能小于开始时间！");
      }

      // 4. 提交
      let params = {
        id: this.form.id,
        endTime: endOfDay,
		schoolId:this.schoolId,
		term:this.form.term,
		year:this.form.year
      };

      this.API.post(this.API.admin.postSchoolSemesterUpdate, params).then((res) => {
          this.$message.success("修改成功");
          this.editVisible = false;
          this.getList();
      });
    },

    // 时间格式化
    formatTime(timestamp) {
      if (!timestamp) return "-";
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let m = (date.getMonth() + 1 + "").padStart(2, "0");
      let d = (date.getDate() + "").padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
  }
};
</script>

<style scoped>
.page-container {
  background: #fff;
  min-height: calc(100vh - 80px);
}
</style>